export const isTextFilled = (text: string) =>
  text.length !== 1 || text.trim() !== '';

export const transformFallbackValue = (
  fallbackValue?: '' | null,
  required?: boolean,
) => fallbackValue ?? (required ? '' : null);
